import { Card, Col } from "reactstrap";
import CommonTable from "../Common/CommonTable";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { InverseTablWithPrimaryBackgrounds } from "../../../../Constant";
import { INVERSETABLE_WITH_BACKGROUND, INVERSETABLE_WITH_BACKGROUND_HEAD, INVERSETABLE_WITH_BACKGROUND_HEAD_BODY } from "../../../../Data/BootstrapTable/BasicTable";

export default function InverseTablePrimary() {
  return (
    <Col sm={12}>
        <Card>
         <CommonCardHeader title={InverseTablWithPrimaryBackgrounds} span={INVERSETABLE_WITH_BACKGROUND} table />
         <CommonTable strip headData={INVERSETABLE_WITH_BACKGROUND_HEAD} tableClass='bg-primary' headClass='tbl-strip-thad-bdr' >
            {INVERSETABLE_WITH_BACKGROUND_HEAD_BODY.map((data) => (
              <tr key={data.id}>
                <th scope="row">{data.id}</th>
                <td>{data.firstName}</td>
                <td>{data.lastName}</td>
                <td>{data.company}</td>
                <td>{data.salary}</td>
                <td>{data.email}</td>
                <td>{data.position}</td>
                <td>{data.country}</td>
              </tr>
            ))}
         </CommonTable>
        </Card>
    </Col>
  )
}